// Confirmation dialog shown before deleting a blog post.
// Extracted from BlogsPage.js.

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {{ title?: string } | null} props.blogToDelete - blog whose title is shown in the confirm message.
 * @param {() => void} props.onConfirm - called when user clicks Delete.
 */
const DeleteBlogDialog = ({ open, onClose, blogToDelete, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Delete Blog Post</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to delete the blog post "{blogToDelete?.title}"? This action cannot be undone.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteBlogDialog;
